import React from 'react';
import '../styles/TypingIndicator.css';

function TypingIndicator({ label = 'AI is typing', className = '' }) {
  const rootClassName = ['typing-indicator', className].filter(Boolean).join(' ');

  return (
    <div
      className={rootClassName}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <span className="typing-indicator-dot" aria-hidden="true" />
      <span className="typing-indicator-dot" aria-hidden="true" />
      <span className="typing-indicator-dot" aria-hidden="true" />
    </div>
  );
}

export default TypingIndicator;
